<template>
  <div class="min-h-screen flex items-center justify-center bg-background">
    <div class="max-w-md w-full mx-auto text-center px-4">
      <div class="mb-8">
        <!-- 500 Icon -->
        <div class="mx-auto w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mb-6">
          <svg class="w-12 h-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>

        <!-- Error Code -->
        <h1 class="text-6xl font-bold text-text-primary mb-4">500</h1>

        <!-- Error Title -->
        <h2 class="text-2xl font-semibold text-text-primary mb-4">Internal Server Error</h2>

        <!-- Error Description -->
        <p class="text-text-secondary mb-8">
          Oops! Something went wrong on our end. Our team has been notified and we're working to fix this issue.
        </p>
      </div>

      <!-- Status Info -->
      <div class="mb-8 p-4 bg-red-50 border border-red-200 rounded-lg">
        <div class="flex items-center justify-center text-sm text-red-700">
          <svg class="w-4 h-4 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"></path>
          </svg>
          <span>Error ID: {{ errorId }}</span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="space-y-4">
        <button
            @click="refreshPage"
            class="w-full bg-primary hover:bg-primary-dark text-white font-medium py-3 px-6 rounded-md transition-colors"
        >
          Try Again
        </button>

        <router-link
            to="/"
            class="block w-full bg-background-light hover:bg-background-lighter text-text-primary font-medium py-3 px-6 rounded-md border border-background-lighter transition-colors"
        >
          Return to Home
        </router-link>
      </div>

      <!-- Additional Help -->
      <div class="mt-8 pt-8 border-t border-background-lighter">
        <p class="text-sm text-text-secondary mb-4">If the problem persists:</p>
        <div class="flex justify-center space-x-6 text-sm">
          <router-link to="/contact" class="text-primary hover:underline">Report Issue</router-link>
          <a href="mailto:support@eskrag.com" class="text-primary hover:underline">Email Support</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InternalServerError',
  data() {
    return {
      errorId: this.generateErrorId()
    }
  },
  methods: {
    generateErrorId() {
      return Math.random().toString(36).substr(2, 9).toUpperCase();
    },
    refreshPage() {
      window.location.reload();
    }
  },
  mounted() {
    document.title = '500 - Internal Server Error | Eskrag';

    // Log error for debugging (optional)
    console.error(`500 Error - ID: ${this.errorId}`, {
      timestamp: new Date().toISOString(),
      url: window.location.href,
      userAgent: navigator.userAgent
    });
  }
}
</script>
